export enum AccountStateName {
    Active = 'active',
    Unbilled = 'unbilled',
    Disabled = 'disabled',
    Blocked = 'blocked'
}

/**
 * 1XX - rules violation
 * 2XX - payment issues
 * 3XX - customer actions
 */
export enum AccountBlockedCode {
    RegularPaymentFailed = '201',
    InitialPaymentTimeoutExpired = '202',
    SubscriptionPaused = '301'
}